import React, { CSSProperties, ReactNode } from 'react';
import {
  Link,
  Route,
  RouteObject,
  BrowserRouter,
  Routes,
} from 'react-router-dom';
import routes from './pages/routes';

import './App.css';
import Layout from './pages/Layout';
import { AuthContextValue, useAuth } from './providers/AuthProvider';
import GuestLayout from './components/GuestLayout';
import BaseLayout from './components/BaseLayout';

function App() {
  const auth = useAuth();
  const user = auth?.user;

  const renderWithLayout = (element: ReactNode) => (
    <BaseLayout>{element}</BaseLayout>
  );

  const renderRoute = (route: RouteObject) => (
    <Route
      key={route.path}
      path={route.path}
      element={
        user && route.path === '*'
          ? route.element
          : renderWithLayout(route.element)
      }
    />
  );

  return (
    <BrowserRouter>
      <Routes>{routes.map(renderRoute)}</Routes>
    </BrowserRouter>
  );
}

export default App;
